import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { element } from 'protractor';
import { AdminAction } from 'src/app/models/adminaction.model';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { DateFormatter } from 'src/app/models/datepickerformatterutil';
import { abridgedclass } from 'src/app/models/module/moduledetails';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
declare var $: any;
@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class CreateComponent implements OnInit {
  moduleinfo: any;
  edit: boolean = false;
  lesson: abridgedclass = new abridgedclass();
  classid: number;
  moduleid: number;
  currentuserid: number
  publishdate:any
  //@Output() reloadlesson: EventEmitter<any> = new EventEmitter();
  //showform: boolean;
  //lessonlist: any;
  isFetchingData: boolean;
  //adminActions: AdminAction[];
  //addAdminError: any;
  //message: any;
  breadcrumbs: BreadCrumb[] = [];
  constructor(public headerinfo: ComponentheaderService, private classmanager: ClassmanagementService, private modulemanager: ModulemanagementService, private userservice: UseraccessserviceService, private router: Router, private activatedroute: ActivatedRoute, private toastr: ToastrService) {
    headerinfo.setHeaderDisplay('Loading Lesson...', [], []);
  }

  async ngOnInit() {
    await this.getLessonInfo();
  }

  async getLessonInfo() {

    this.classid = this.activatedroute.snapshot.queryParams.classid;
    //let moduleid = this.activatedroute.snapshot.queryParams.moduleid;
    this.isFetchingData = true;
    let moduledata: any;
    let moduleinfo;
    if (this.classid)//if classid, then we are editing
    {
      const data = await this.classmanager.getClassDetailsAbridged(this.classid).toPromise();
      //debugger;
      this.lesson = data;
      // this.lesson.publishdate = new Date(this.lesson.publishdatestring);
      
      moduledata = await this.modulemanager.getModuleDetails(this.lesson.moduleid).toPromise();
      moduleinfo = moduledata.moduleinfo;
      this.publishdate=this.lesson.publishdate;
      console.log("Data School Info")
      console.log(data);
    }
    else {//otherwise, we are adding
      //debugger;
      this.moduleid = parseInt(this.activatedroute.snapshot.queryParams.moduleid);
      this.lesson.moduleid = this.moduleid;
      this.lesson.classposition = 0;
      this.lesson.id = 0;
      moduledata = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();
      moduleinfo = moduledata.moduleinfo;
      this.publishdate="";
    }
    this.currentuserid = moduledata.currentuserid;
    let moduleDisplayName = moduleinfo.name;
    const coursecode = moduleinfo.courseCode;
    if (coursecode) {
      moduleDisplayName += ` (${coursecode})`;
    }

    this.breadcrumbs = [
      
      { displaytext:"School", route: `/user/schoolhome` },
      { displaytext: "Course", route: `/user/moduledetails`, params: { moduleID: moduleinfo.id } }
    ];

    if (this.classid) {
      this.breadcrumbs.push({ displaytext: this.lesson.title, route: '/user/lesson', params: { classid: this.lesson.id } });
    }

    this.breadcrumbs.push({ displaytext: this.classid ? 'Edit' : 'New', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams });

    this.headerinfo.setHeaderDisplay(
      moduleDisplayName,
      this.breadcrumbs,
      []);


    //   (err: HttpErrorResponse) => {
    //     if (err.status === 0) {
    //       this.toastr.error("Unable to connect to server");
    //     }
    //     else if (err.status === 400) {
    //       this.toastr.error(err.error.message);
    //     }
    //     this.isFetchingData = false;
    //   }
    // );
  }


  async addlesson() {
    //debugger;
    this.isFetchingData = true;
    //debugger;
    //await this.calcTime()
    this.classmanager.addeditclass(this.lesson).subscribe(
      (data: abridgedclass) => {
        // this.isFetchingData = false;
        // if (!this.edit) {
        //   this.lesson = new abridgedclass();
        //   this.lesson.moduleid = this.moduleinfo.id;
        // }
        // else {
        //   this.canceledit(this.lesson.title);
        // }
        this.router.navigate(['/user/lesson'], { queryParams: { classid: data.id, moduleid: this.moduleid } });
        this.toastr.success("Successfully added");

      },
      (err: HttpErrorResponse) => {
        if (err.status === 0) {
          this.toastr.error("Unable to connect to server");
        }
        else if (err.status === 400) {
          this.toastr.error(err.error.message);
        }
        this.isFetchingData = false;
      }
    );
  }

  // clearmsg() {
  //   this.message = null;
  //   this.addAdminError = null;
  // }

  canceledit() {
    if (this.classid) {
      //'/user/lesson', params: {classid: this.lesson.id}
      this.router.navigate(['/user/lesson'], { queryParams: { classid: this.classid } });
    }
    else {
      this.router.navigate(['/user/moduledetails'], { queryParams: { moduleID: this.moduleid } });
    }
  }

  // async calcTime() {
  //   //debugger;
  //   // // var profile = await this.userservice.getuserprofile(this.currentuserid).toPromise();
  //   // var date = this.lesson.publishdate.toString();
  //   // var targetTime = new Date(date);
  //   // // var timeZoneFromDB = profile.timeZone
  //   // // this.lesson.publishdate = new Date(targetTime.getTime() + ((-timeZoneFromDB) * 3600 * 1000));
  //   // var dateString =
  //   //   targetTime.getFullYear() + "/" +
  //   //   ("0" + (targetTime.getMonth() + 1)).slice(-2) + "/" +
  //   //   ("0" + targetTime.getDate()).slice(-2) + " " +
  //   //   ("0" + targetTime.getHours()).slice(-2) + ":" +
  //   //   ("0" + targetTime.getMinutes()).slice(-2) + ":" +
  //   //   ("0" + targetTime.getSeconds()).slice(-2);

  //   // this.lesson.publishdatestring = dateString;

  // let dt=  $("#publishdate")[0];

  // let publishDate= DateFormatter.convertDate(dt.value);
  // this.lesson.publishdate=publishDate;

  // }
}
